
import React, {useCallback, useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DevicesIcon from '@material-ui/icons/Devices';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TuneIcon from '@material-ui/icons/Tune';
import RemoveFromQueueIcon from '@material-ui/icons/RemoveFromQueue';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import Divider from '@material-ui/core/Divider';
import StorefrontIcon from '@material-ui/icons/Storefront';
import PersonIcon from '@material-ui/icons/Person';
import BlockIcon from '@material-ui/icons/Block';
import Button from '@material-ui/core/Button';

import ComputeFeedbackDialog from '@user-pages/exercise/common/ComputeFeedbackDialog'

import AuthProvider from '@user-provider/AuthProvider'
import PrescriptionService from '@user-service/PrescriptionService'
import ProfileService from '@user-service/ProfileService'
import ConfigService from '@user-service/ConfigService'

import clsx from "clsx";
import {Typography} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import BridgeProvider from "../../provider/BridgeProvider";

const Setting = ({history}) => {
    const classes = useStyles();
    const settingDialogRef = React.createRef()

    const handleDevice = () => {
        history.push('/setting/deviceManage')
    };
    
    const handleVoucher = () => {
        history.push('/voucher')
    }
    
    const handleNoise = () => {
        history.push('/setting/noiseManage')
    }

    const handleComputerManage = () => {
        history.push('/setting/computerManage')
    }
    
    const handleHzDefault = () => {
        settingDialogRef.current.openWithHzType('default')
    }
    
    const handleHzMeditation = () => {
        settingDialogRef.current.openWithHzType('meditationTest')
    }
    
    const handleCheckNoise = async () => {
        const prescription = await PrescriptionService.getLatest();
        history.push(`/measureBand/${prescription.id}?noiseCode=N`)
    }
    
    const handleManagers = () => {
        history.push(`/setting/managers`)
    }

    const handleUnblockDevice = async () => {
        if (!state.deviceBlock.deviceSerial) return

        const confirmed = window.confirm('기기 사용정지를 해지하시겠습니까?')
        if (!confirmed) return

        const success = await ConfigService.unblockDevice(state.deviceBlock.deviceSerial)
        if (success) {
            setState({
                ...state,
                deviceBlock: {
                    isBlocked: false,
                    deviceSerial: state.deviceBlock.deviceSerial
                }
            })
            alert('기기 사용정지가 해지되었습니다.')
        } else {
            alert('해지 처리 중 오류가 발생했습니다.')
        }
    }
    
    const [state, setState] = useState({
        computerInfo: {
            computerName: '...',
            version: '...'
        },
        manager: {name: ''},
        noiseFilterType: 'default',
        deviceBlock: {
            isBlocked: false,
            deviceSerial: ''
        }
    })

    const noiseFilterDescriptions = {
        'default': {
            title: '기본 (Default)',
            method: '단순 차감 방식',
            formula: 'result = signal - noise (음수일 경우 0)',
            features: [
                '가장 빠른 처리 속도',
                '기존 로직과 동일',
                '단순하고 예측 가능한 결과'
            ]
        },
        'type1': {
            title: 'TYPE1 - Spectral Subtraction + Wiener Filter',
            method: '스펙트럼 차감 + 위너 필터 조합',
            formula: 'Spectral Subtraction (α=1.2) → Spectral Floor (β=0.01) → Wiener Filter (SNR 기반)',
            features: [
                '음성 처리 분야에서 검증된 알고리즘',
                '과잉차감(α=1.2)으로 노이즈 공격적 제거',
                'Spectral Floor로 음수 방지',
                'SNR 기반 Wiener Filter로 신호 품질 향상',
                'Musical Noise 최소화'
            ]
        },
        'type2': {
            title: 'TYPE2 - Butterworth IIR Filter (EEG 최적화)',
            method: 'IIR Notch + Lowpass + Spectral Subtraction',
            formula: '60Hz Notch Filter (Q≈40) → 40Hz Lowpass → Spectral Subtraction',
            features: [
                '의료/연구용 EEG 장비 표준 필터',
                '60Hz 전원 노이즈 정밀 제거 (대역폭 1.5Hz)',
                '40Hz 이상 고주파 차단',
                'Butterworth 특성으로 평탄한 통과대역',
                '실시간 처리에 적합한 IIR 구조'
            ]
        },
        'type4': {
            title: 'TYPE4 - FIR 선형위상 필터 (임상/연구용 권장)',
            method: 'FIR Bandpass + FIR Notch + Spectral Subtraction',
            formula: 'FIR Bandpass 0.5-50Hz (order=250) → FIR Notch 59-61Hz → Spectral Subtraction',
            features: [
                '선형위상 특성으로 위상 왜곡 없음',
                '정밀한 EEG 분석에 최적',
                '0.5Hz 이하 DC 드리프트 제거',
                '50Hz 이상 고주파 차단',
                '임상/연구 표준 사양',
                'order=250 고품질 필터링'
            ]
        }
    }

    const handleNoiseFilterChange = async (e) => {
        const newFilterType = e.target.value
        setState({
            ...state,
            noiseFilterType: newFilterType
        })

        // 서버에 저장
        const profileId = AuthProvider.getProfileID()
        if (profileId) {
            await ConfigService.saveNoiseFilterType(profileId, newFilterType)
        }
    }
    
    const fetch = useCallback(async () => {
        let computerInfo = {
            version: '',
            computerName : ''
        }

        let manager = {name: ''}
        let noiseFilterType = 'default'
        let deviceBlock = { isBlocked: false, deviceSerial: '' }
        let deviceSerial = ''

        try {
            // await window.CefSharp.BindObjectAsync('BRHW')
            const version = await BridgeProvider.instance.getVersion()
            const computerName = await BridgeProvider.instance.getComputerName()
            deviceSerial = await BridgeProvider.instance.getDeviceSerial()

            computerInfo = {
                version,
                computerName
            }
        } catch(e) {}

        try {
            const managers = await ProfileService.getManager()
            if(0 < managers.length){
                manager = managers[0]
            }
        } catch {}

        // 노이즈 필터 타입 불러오기
        try {
            const profileId = AuthProvider.getProfileID()
            if (profileId) {
                noiseFilterType = await ConfigService.getNoiseFilterType(profileId)
            }
        } catch {}

        // 기기 사용정지 상태 조회
        try {
            if (deviceSerial) {
                deviceBlock = await ConfigService.getDeviceBlockStatus(deviceSerial)
            }
        } catch {}

        setState({
            ...state,
            computerInfo,
            manager,
            noiseFilterType,
            deviceBlock
        })
    },[])
    
    useEffect(()=>{
        fetch().then()
    },[])

    
    const { computerInfo, manager } = state

    return (
        <div id="cont-wrap" >
            <div className="sv" >
                <div>
                    <h3>설정</h3>
                </div>
            </div>
            <div className={clsx('cont', classes.root)} >
                {AuthProvider.isAdmin() &&
                <EducatorCode/>
                }
                <List
                    style={{marginTop: 30}}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            기기 관리
                        </ListSubheader>
                    }
                    className={classes.listRoot}
                >
                    {AuthProvider.isSuperAdmin() &&
                      <React.Fragment>
                        <ListItem button className={'item'}>
                          <ListItemIcon>
                            <DevicesIcon/>
                          </ListItemIcon>
                          <ListItemText primary="노이즈 필터 타입(wolfsrain32, ygj0028 만 적용)" />
                          <ListItemSecondaryAction>
                            <select
                              value={state.noiseFilterType}
                              onChange={handleNoiseFilterChange}
                              style={{padding: '8px 12px', fontSize: '14px', borderRadius: '4px'}}
                            >
                              <option value="default">기본</option>
                              <option value="type1">TYPE1</option>
                              <option value="type2">TYPE2</option>
                              <option value="type4">TYPE4 (권장)</option>
                            </select>
                          </ListItemSecondaryAction>
                        </ListItem>
                        {/* 노이즈 필터 상세 설명 */}
                        <Box sx={{p: 2}} style={{padding: '16px 20px', backgroundColor: '#f8f9fa', borderLeft: '4px solid #1976d2'}}>
                          {(() => {
                            const desc = noiseFilterDescriptions[state.noiseFilterType];
                            return (
                              <div>
                                <Typography variant="h6" style={{fontWeight: 'bold', marginBottom: '12px', color: '#1976d2'}}>
                                  {desc.title}
                                </Typography>
                                <Typography variant="body1" style={{marginBottom: '12px', fontSize: '16px'}}>
                                  <strong>처리 방식:</strong> {desc.method}
                                </Typography>
                                <Typography variant="body1" style={{marginBottom: '16px', fontFamily: 'monospace', backgroundColor: '#e9ecef', padding: '12px', borderRadius: '4px', fontSize: '15px'}}>
                                  {desc.formula}
                                </Typography>
                                <Typography variant="body1" style={{fontWeight: 'normal', marginBottom: '8px', fontSize: '18px'}}>주요 특징:</Typography>
                                <ul style={{margin: '0', paddingLeft: '24px'}}>
                                  {desc.features.map((feature, idx) => (
                                    <li key={idx} style={{fontSize: '18px', fontWeight: 'normal', marginBottom: '6px', lineHeight: '1.5'}}>{feature}</li>
                                  ))}
                                </ul>
                              </div>
                            );
                          })()}
                        </Box>
                        <Divider />
                      </React.Fragment>
                    }
                 
                    
                    {AuthProvider.isSuperAdmin() &&
                    <React.Fragment>
                        <ListItem button className={'item'}>
                            <ListItemIcon>
                                <DevicesIcon/>
                            </ListItemIcon>
                            <ListItemText primary="노이즈 측정" onClick={handleCheckNoise}/>
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                    }

                    {AuthProvider.isSuperAdmin() &&
                    <React.Fragment>
                        <ListItem button className={'item'} onClick={handleNoise}>
                            <ListItemIcon>
                                <TuneIcon />
                            </ListItemIcon>
                            <ListItemText primary="노이즈 설정" />
                            <ListItemSecondaryAction>
                                <IconButton aria-label="delete">
                                    <ChevronRightIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                    }
                    {AuthProvider.isSuperAdmin() &&
                    <React.Fragment>
                        <ListItem button className={'item'} onClick={handleHzDefault}>
                            <ListItemIcon>
                                <TuneIcon />
                            </ListItemIcon>
                            <ListItemText primary="균형상태 설정" />
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                    }
                    {AuthProvider.isSuperAdmin() &&
                    <React.Fragment>
                        <ListItem button className={'item'} onClick={handleHzMeditation}>
                            <ListItemIcon>
                                <TuneIcon />
                            </ListItemIcon>
                            <ListItemText primary="뇌기능 의식패턴 설정" />
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                    }
                    
                    <ListItem button className={'item'} onClick={handleDevice}>
                        <ListItemIcon>
                            <DevicesIcon />
                        </ListItemIcon>
                        <ListItemText primary="기기 연결 관리" />
                        <ListItemSecondaryAction>
                            <IconButton aria-label="delete">
                                <ChevronRightIcon />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />


                  {state.deviceBlock.isBlocked && AuthProvider.isSuperAdmin() &&
                    <Box
                      style={{
                        backgroundColor: '#fff3f3',
                        border: '2px solid #f44336',
                        borderRadius: '8px',
                        margin: '16px 0',
                        padding: '20px',
                        boxShadow: '0 2px 8px rgba(244, 67, 54, 0.25)'
                      }}
                    >
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                          <BlockIcon style={{ fontSize: 48, color: '#f44336' }} />
                        </Grid>
                        <Grid item xs>
                          <Typography variant="h6" style={{ color: '#d32f2f', fontWeight: 'bold', marginBottom: '4px' }}>
                            ⚠️ 기기 사용정지 상태
                          </Typography>
                          <Typography variant="body2" style={{ color: '#666' }}>
                            이 기기는 현재 사용이 정지되어 있습니다.
                          </Typography>
                          <Typography variant="caption" style={{ color: '#999' }}>
                            시리얼: {state.deviceBlock.deviceSerial}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleUnblockDevice}
                            style={{
                              backgroundColor: '#f44336',
                              color: '#fff',
                              fontWeight: 'bold',
                              padding: '10px 24px'
                            }}
                          >
                            사용정지 해지
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  }
                  </List>
                  

                <List
                    style={{marginTop: 30}}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            컴퓨터 관리
                        </ListSubheader>
                    }
                    className={classes.listRoot}
                >
                    <ListItem className={'item'}>
                        <ListItemIcon>
                            <RemoveFromQueueIcon />
                        </ListItemIcon>
                        <ListItemText primary="컴퓨터 이름" />
                        <ListItemSecondaryAction>
                            {computerInfo.computerName}
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />

                    <ListItem className={'item'}>
                        <ListItemIcon>
                            <RemoveFromQueueIcon />
                        </ListItemIcon>
                        <ListItemText primary="BRHW 버전" />
                        <ListItemSecondaryAction>
                            {computerInfo.version}
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    
                    <ListItem button className={'item'} onClick={handleComputerManage}>
                        <ListItemIcon>
                            <ImportantDevicesIcon />
                        </ListItemIcon>
                        <ListItemText primary="컴퓨터 상태" />
                        <ListItemSecondaryAction>
                            <IconButton aria-label="delete">
                                <ChevronRightIcon />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                </List>

                <List
                    style={{marginTop: 30}}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            담당 교육사
                        </ListSubheader>
                    }
                    className={classes.listRoot}
                >
                    <ListItem className={'item'} button onClick={handleManagers}>
                        <ListItemIcon>
                            <PersonIcon />
                        </ListItemIcon>
                        <ListItemText primary="담당 교육사 " />
                        <ListItemSecondaryAction>
                            <Grid container>
                                <Grid item>
                                    <div style={{paddingTop: 10, paddingRight: 10}}>
                                        {manager.name ? manager.name : '등록필요'}
                                    </div>    
                                </Grid>
                                <Grid item>
                                    <IconButton aria-label="delete">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                </List>
                
                
                <List
                    style={{marginTop: 30}}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            결제 관리
                        </ListSubheader>
                    }
                    className={classes.listRoot}
                >
                    {/*<ListItem button className={'item'}>*/}
                    {/*    <ListItemIcon>*/}
                    {/*        <PaymentIcon />*/}
                    {/*    </ListItemIcon>*/}
                    {/*    <ListItemText primary="카드 관리" />*/}
                    {/*    <ListItemSecondaryAction>*/}
                    {/*        <IconButton aria-label="delete">*/}
                    {/*            <ChevronRightIcon />*/}
                    {/*        </IconButton>*/}
                    {/*    </ListItemSecondaryAction>*/}
                    {/*</ListItem>*/}
                    {/*<Divider />*/}

                    <ListItem button className={'item'} onClick={handleVoucher}>
                        <ListItemIcon>
                            <StorefrontIcon />
                        </ListItemIcon>
                        <ListItemText primary="상품 구매" />
                        <ListItemSecondaryAction>
                            <IconButton aria-label="delete">
                                <ChevronRightIcon />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                </List>
            </div>
            <ComputeFeedbackDialog ref={settingDialogRef} hzType={'default'} />
        </div>
    );
}

const EducatorCode = () => {
    const classes = useStyles();
    let image = AuthProvider.getProfileImage();
    return (
        <Box border={1} mt={3} p={5} style={{borderColor: '#ddd', borderRadius: 10}}>
            <Grid container>
                <Grid item xs={2}>
                    <Avatar variant="rounded" className={classes.large} alt={AuthProvider.getProfileName()} src={image}/>
                </Grid>
                <Grid item xs={10}>
                    <Typography variant={'subtitle1'}>
                        교육사 코드
                    </Typography>
                    <Typography variant={'h5'}>
                        {AuthProvider.get('code')}
                    </Typography>
                    <Typography variant={'caption'} style={{color: '#999'}}>
                        브레인헬스 본사
                    </Typography>
                </Grid>
            </Grid>
            
        </Box>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 800,
        margin: 'auto',
        
        '& .item': {
            padding : '20px 10px'
        },
        
    },
    listRoot: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    large: {
        width: theme.spacing(12),
        height: theme.spacing(12),

        // backgroundColor: 'transparent',
        '& img': {
            width: '100%'
        }
    },
}));

export default Setting
